module.exports = __webpack_public_path__ + "assets/img/be1551cb80efd4cb232a49cbb879f6a2.png";